import React from 'react';

import styles from './styles.module.less';

const FooterButton = (props) => (
  <div className={styles.form_footer} {...props}>
    {props.children}
  </div>
);


export default FooterButton;